export default __webpack_public_path__ + "static/media/OpenTaskIconLight.56bbcfa5.svg";